import React from 'react'
import sampleImg1 from '../../assets/images/PlayerScreen/myPic.jpg'
import pak from '../../assets/images/PlayerScreen/pak.png'
import dia from '../../assets/images/PlayerScreen/dia.png'
import crown from '../../assets/images/PlayerScreen/crown.svg'
import '../../assets/css/style.scss'
import '../../assets/css/challange.scss'
import Host from '../Host'
import TodayPrizeCard from '../TodayPrize/todayPrizeCard'

const Congra = ({nextNav}) => {
  return (
  <>
  
  <div className="row" >

<div className="col-12 challange-congra-header mt-3 mb-0 d-flex justify-content-center" style={{height:"17%"}}>
CONGRATULATIONS!
</div>

<div className="col-12 mb-3" >

<div className="row">

<div className="col-3"></div>
<div className="col-6 ">

<div className=" my-0 " >

<div className="player-screen-body-border" >

  <div className="row ">

    <div className="col-3  position-relative ">
      <img className='player-screen-card-profile m-1' src={sampleImg1} alt="" />

      <div className='position-absolute player-screen-card-crown pr-1'>
        <img className='challange-crown'  src={crown} alt="" />
      </div>

    </div>

    <div className="col-3 px-0">

      <div className='challange-card-div1  '>

        <img player-screen-card-img1 src={pak} alt="" /> <span className='challange-card-text1 text-light'>Hafiz F</span>

      </div>

      <div className='challange-card-div2'>

        <img player-screen-card-img2 src={dia} alt="" />  <span className='challange-card-text2 text-light'>Hafiz F1</span>

      </div>


    </div>

    <div className="col-6 px-0 ">
    <i class="fa-solid fa-star " style={{color:"green", width:"2%", height:"2%", marginRight:"13%", marginTop:"8%"}}></i>
    <i class="fa-solid fa-star " style={{color:"green", width:"2%", height:"2%", marginRight:"13%", marginTop:"8%"}}></i>
    <i class="fa-solid fa-star " style={{color:"green", width:"2%", height:"2%", marginRight:"13%", marginTop:"8%"}}></i>
    <i class="fa-solid fa-star " style={{color:"green", width:"2%", height:"2%", marginRight:"13%", marginTop:"8%"}}></i>
    <i class="fa-solid fa-star " style={{color:"green", width:"2%", height:"2%", marginRight:"13%", marginTop:"8%"}}></i>
    </div>

  </div>

</div>

</div>

</div>
<div className="col-3"></div>

</div>

</div>
{
  console.log("first", nextNav)
}
{
  nextNav ===3 && (<div className="col-12 " style={{height:"100%"}}>

  <TodayPrizeCard marginLeftCongra="0.1%" />
  
  </div>)
}



<div className="col-12 position-absolute text-light" style={{ top: "84.5%", left: "52.88%", transform: "translate(-50%, -50%)"  }}>

                    <Host />

                </div>

</div>
  
  
  </>
  )
}

export default Congra